import angular from 'angular'
import template from './template.html'

angular.module('nominas.informacionfiscal')
  .component('nominasInformacionfiscal', {
    template: template,
    controller: Component,
  });

function Component($q, $filter, $catalogos, CatalogoEjerciciosFiscales) {
  let $ctrl = this;

  $ctrl.$onInit = $onInit;
  $ctrl.CatalogoEjerciciosFiscales = CatalogoEjerciciosFiscales

  function $onInit() {
    $ctrl.seleccion = null;

    $ctrl.promise = $q.all({
        empresas: $catalogos.get('empresas')
          .then(function (empresas) {
            $ctrl.empresas = $filter('orderBy')(empresas, 'Nombre');
          }),
        ejercicios_fiscales: $ctrl.CatalogoEjerciciosFiscales.get()
          .then(function (response) {
            $ctrl.ejercicios_fiscales = response.data;
          }),
      });
  }
}



// WEBPACK FOOTER //
// ./src/nominas/informacionfiscal/components/component.js